import React, { useState } from "react";
import { Link, withRouter } from "react-router-dom";
import style from "./EnterPhoneNum.module.scss";
import Input from '../../../input/signInput/input';
import Button from '../../../Button/button'
import toEnglishNumber from "../../../../helpers/actions/toEnglishNumber";
import { forgetPassword } from "../../../../actions/APIcalls";
import Toast from '../../../Toast/Toast';

const EnterPhoneNum = (props) => {

    const [tel, setTel] = useState('')
    const [err, setErr] = useState('')

    const handleBlure = () => {
        if (tel.length !== 0) {
            setErr('')
        } else {
            setErr('شماره موبایل خود را وارد کنید')
        }

    }
    const [showToast, setShowToast] = useState({ show: false, text: "" });
    const [loading, setLoading] = useState(false);

    const recoverAcount = async () => {
        let reg = new RegExp("^(09)[0-9]{9}$");
        if (tel.length !== 0) {
            if (reg.test(toEnglishNumber(tel))) {
                setLoading(true)
                const res = await forgetPassword({ phone: tel });
                if (typeof res !== "undefined" && typeof res.data !== "undefined" && res.data.success) {
                    props.history.push(
                        {
                            pathname: '/signin/code',
                            state: { tel: tel }
                        }
                    )
                    setLoading(false)
                } else {
                    if (typeof res.response !== "undefined") {
                        setShowToast({ show: true, text: res.response.data.error })
                    }
                    setLoading(false)
                }
            } else {
                setErr('شماره وارد شده صحیح نیست!')
            }
        } else {
            setErr('شماره موبایل خود را وارد کنید')
        }
    }

    const handleForm = (tag, e) => {
        if (tag === 'tel') {
            let temp1 = tel;
            let reg = new RegExp(/^\d+$/);
            console.log(reg.test(temp1), e.target.value, "54545");
            if (reg.test(toEnglishNumber(e.target.value)) && e.target.value.length < 12) {
                temp1 = toEnglishNumber(e.target.value);
            } else if (e.target.value === "") {
                console.log("empty");
                temp1 = ""
            }
            setTel(toEnglishNumber(temp1))
        }
    }

    return (
        <React.Fragment>
            <div className={style.signUpStepOne}>
                <Toast
                    tag='forgetPassword'
                    value={showToast.show}
                    text={showToast.text}
                    parentClose={() => setShowToast({ show: false, text: "" })}
                />

                {/* <p className={style.signinLinkText}>حساب‌کاربری ندارید؟<span><Link
                    to='/signup/stepone'>ثبت‌نام</Link></span></p> */}

                <div className={style.stepOneFrame}>
                    <h3>بازیابی رمز عبور</h3>
                    <div className={style.stepOneFormFrame}>
                        <p className={style.requesting}>لطفا برای بازیابی رمز عبور، شماره تلفن همراه خود را وارد
                            کنید.</p>

                        <div className={style.inputWrapper} onKeyDown={(event) =>
                            event.key === "Enter" ? recoverAcount() : null}>
                            <Input
                                type="text"
                                disabled={false}
                                label="شماره موبایل"
                                placeholder=" - - - - - - - - - ۰۹"
                                tag="tel"
                                value={tel}
                                error={err}
                                tooltip=''
                                onchange={handleForm}
                                onblur={handleBlure}
                            />
                        </div>
                    </div>
                    <div className={style.buttonWrapper}>
                        <Button
                            loading={loading}
                            disabled={false}
                            tag="recover"
                            type="solid"
                            label="بازیابی رمز عبور"
                            onclick={recoverAcount}
                        />
                        <p className={style.registerLink}>حساب‌کاربری ندارید؟
                            <span className={style.link}>
                                <Link
                                    to='/signup/stepone'>ثبت‌نام در موبیشا</Link>
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default withRouter(EnterPhoneNum);